import TwitterTimelineWidget from "QuorumGrassroots/widgets/TwitterTimeline/components/index"

export default TwitterTimelineWidget
